import { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';
import { useLanguage } from '../utils/LanguageContext';
import translations from './MarketingLeadForm.lang.json';
import { leadRegistration } from '../utils/api';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './MarketingLeadForm.css';

const MarketingLeadForm = () => {
  const { lang } = useLanguage(translations);
  // const [formState, setFormState] = useState({ username: '', email: '' }); // fixed react warnings
  const [formState] = useState({ username: '', email: '' });
  const [error, setError] = useState(null);
  const [signupSuccess, setSignupSuccess] = useState(false);
  const location = useLocation();
//TODO: Scale this code across site to set user to top of page everytime they're routed to a new page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleFormSubmit = async (formValues) => {
    try {
      const response = await leadRegistration(formValues);
      if (!response.ok) {
        setError(lang('formError'));
      }
      // const data = await response.json(); // fixed react warnings
      await response.json();
      setSignupSuccess(true);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="page-container">
      <h3 className="marketingPageTitle">{lang('pageTitle')}</h3>
      {!signupSuccess ? (
        <Form layout="vertical" onFinish={handleFormSubmit} initialValues={formState}>
          <div className="form-input-group">
            <Form.Item
              label={lang('firstName')}
              name="givenName"
              rules={[
                {
                  required: true,
                  message: lang('firstNameRequired'),
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                // placeholder={lang('firstNamePlaceholder')}
              />
            </Form.Item>
            <Form.Item
              label={lang('lastName')}
              name="familyName"
              rules={[
                {
                  required: true,
                  message: lang('lastNameRequired'),
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                // placeholder={lang('lastNamePlaceholder')}
              />
            </Form.Item>
            <Form.Item
              label={lang('email')}
              name="email"
              rules={[
                {
                  required: true,
                  message: lang('emailRequired'),
                  type: 'email',
                },
              ]}
            >
              <Input
                prefix={<MailOutlined className="site-form-item-icon" />}
                type="email"
                // placeholder={lang('emailPlaceholder')}
              />
            </Form.Item>
            <Form.Item className="login-form-item">
              <Button type="primary" className="register-button" htmlType="submit">
                {lang('registerButton')}
              </Button>
            </Form.Item>
          </div>
        </Form>
      ) : (
        <div>
          <p className="p-tag">{lang('successMessage')}</p>
        </div>
      )}
      {error && <div>{error}</div>}
    </div>
  );
};

export default MarketingLeadForm;
